import { CampaignImpactStatsMetric } from "api/campaignApi"
import { CampaignDetails } from "modules/Types"

export const campaignDetailsData_mock = {
    "image": "data:image/jpeg;base64,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",
    "campaignName": "Port Antonio Release",
    "campaignStatus": "LIVE",
    "campaignType": "increase_music_streams",
    "budget": {
        "total": 10000,
        "spent": 5390,
        "remaining": 4610
    },
    "campaignLength": {
        "startDate": "01/20/25",
        "endDate": "01/21/25",
        "totalDays": 31,
        "remainingDays": 10
    },
    // can be used for IG + Presaves + YT
    "geographicBreakdown": {
        "countries": [
            {
                "country": "US",
                "countryName": "United States",
                "cpc": 0.138911,
                "reach": 2068,
                "impressions": 2263,
                "clicks": 85,
                "spend": 14.03
            },
            {
                "country": "MX",
                "countryName": "Mexico",
                "cpc": 0.087912,
                "reach": 5995,
                "impressions": 7292,
                "clicks": 53,
                "spend": 8
            },
            {
                "country": "ES",
                "countryName": "Spain",
                "cpc": 0.128033,
                "reach": 3624,
                "impressions": 4286,
                "clicks": 42,
                "spend": 7.81
            },
            {
                "country": "IT",
                "countryName": "Italy",
                "cpc": 0.106182,
                "reach": 2672,
                "impressions": 3267,
                "clicks": 41,
                "spend": 5.84
            },
            {
                "country": "DE",
                "countryName": "Germany",
                "cpc": 0.183243,
                "reach": 1648,
                "impressions": 1675,
                "clicks": 30,
                "spend": 6.78
            },
            {
                "country": "FR",
                "countryName": "France",
                "cpc": 0.110357,
                "reach": 1032,
                "impressions": 1088,
                "clicks": 25,
                "spend": 3.09
            },
            {
                "country": "AU",
                "countryName": "Australia",
                "cpc": 0.091818,
                "reach": 320,
                "impressions": 336,
                "clicks": 9,
                "spend": 1.01
            },
            {
                "country": "PE",
                "countryName": "Peru",
                "cpc": 0.16,
                "reach": 1512,
                "impressions": 1769,
                "clicks": 8,
                "spend": 2.08
            },
            {
                "country": "SE",
                "countryName": "Sweden",
                "cpc": 0.616667,
                "reach": 368,
                "impressions": 400,
                "clicks": 2,
                "spend": 1.85
            },
            {
                "country": "NZ",
                "countryName": "New Zealand",
                "cpc": 0,
                "reach": 112,
                "impressions": 120,
                "clicks": 0,
                "spend": 0.35
            }
        ],
        "regions": [
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Lombardia",
                "cpc": 0.075294,
                "reach": 532,
                "impressions": 698,
                "clicks": 13,
                "spend": 1.28
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Distrito Federal",
                "cpc": 0.094545,
                "reach": 1284,
                "impressions": 1577,
                "clicks": 13,
                "spend": 2.08
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Comunidad de Madrid",
                "cpc": 0.105,
                "reach": 748,
                "impressions": 837,
                "clicks": 10,
                "spend": 1.68
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "State of Mexico",
                "cpc": 0.049412,
                "reach": 812,
                "impressions": 967,
                "clicks": 8,
                "spend": 0.84
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Florida",
                "cpc": 0.133,
                "reach": 164,
                "impressions": 197,
                "clicks": 8,
                "spend": 1.33
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Bayern",
                "cpc": 0.172222,
                "reach": 352,
                "impressions": 401,
                "clicks": 8,
                "spend": 1.55
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Île-de-France",
                "cpc": 0.07,
                "reach": 200,
                "impressions": 203,
                "clicks": 7,
                "spend": 0.56
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Nordrhein-Westfalen",
                "cpc": 0.166667,
                "reach": 328,
                "impressions": 338,
                "clicks": 7,
                "spend": 1.5
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Lima Region",
                "cpc": 0.127273,
                "reach": 968,
                "impressions": 1149,
                "clicks": 7,
                "spend": 1.4
            },
            {
                "country": null,
                "countryName": "Unknown",
                "region": "Cataluña",
                "cpc": 0.139091,
                "reach": 760,
                "impressions": 897,
                "clicks": 7,
                "spend": 1.53
            }
        ],
        "dmas": [
            {
                "dma": "Unknown",
                "reach": 17286,
                "cpc": 0.123211,
                "impressions": 20238,
                "clicks": 210,
                "spend": 36.84
            },
            {
                "dma": "Salt Lake City",
                "reach": 87,
                "cpc": 0.085,
                "impressions": 87,
                "clicks": 6,
                "spend": 0.51
            },
            {
                "dma": "New York",
                "reach": 100,
                "cpc": 0.118333,
                "impressions": 113,
                "clicks": 6,
                "spend": 0.71
            },
            {
                "dma": "Washington, DC (Hagrstwn)",
                "reach": 32,
                "cpc": 0.058,
                "impressions": 39,
                "clicks": 4,
                "spend": 0.29
            },
            {
                "dma": "Denver",
                "reach": 68,
                "cpc": 0.125,
                "impressions": 83,
                "clicks": 4,
                "spend": 0.5
            },
            {
                "dma": "Boston (Manchester)",
                "reach": 60,
                "cpc": 0.1225,
                "impressions": 64,
                "clicks": 4,
                "spend": 0.49
            },
            {
                "dma": "Phoenix (Prescott)",
                "reach": 52,
                "cpc": 0.085,
                "impressions": 55,
                "clicks": 3,
                "spend": 0.34
            },
            {
                "dma": "Orlando-Daytona Bch-Melbrn",
                "reach": 28,
                "cpc": 0.09,
                "impressions": 44,
                "clicks": 3,
                "spend": 0.36
            },
            {
                "dma": "Miami-Ft. Lauderdale",
                "reach": 32,
                "cpc": 0.07,
                "impressions": 37,
                "clicks": 3,
                "spend": 0.21
            },
            {
                "dma": "Las Vegas",
                "reach": 8,
                "cpc": 0.043333,
                "impressions": 17,
                "clicks": 3,
                "spend": 0.13
            }
        ]
    },
    // can be used for IG + Presaves + YT
    "demographicsBreakdown": [
        {
            "age": "25-34",
            "gender": "male",
            "reach": 10679,
            "cpc": 0.124879,
            "impressions": 12325,
            "clicks": 147,
            "spend": 25.85
        },
        {
            "age": "18-24",
            "gender": "male",
            "reach": 3460,
            "cpc": 0.092234,
            "impressions": 4179,
            "clicks": 77,
            "spend": 8.67
        },
        {
            "age": "25-34",
            "gender": "female",
            "reach": 2540,
            "cpc": 0.177255,
            "impressions": 2979,
            "clicks": 37,
            "spend": 9.04
        },
        {
            "age": "18-24",
            "gender": "female",
            "reach": 1408,
            "cpc": 0.1548,
            "impressions": 1554,
            "clicks": 20,
            "spend": 3.87
        },
        {
            "age": "35-44",
            "gender": "male",
            "reach": 932,
            "cpc": 0.128889,
            "impressions": 1105,
            "clicks": 10,
            "spend": 2.32
        },
        {
            "age": "35-44",
            "gender": "female",
            "reach": 184,
            "cpc": 0.243333,
            "impressions": 202,
            "clicks": 2,
            "spend": 0.73
        },
        {
            "age": "35-44",
            "gender": "unknown",
            "reach": 4,
            "cpc": 0.04,
            "impressions": 7,
            "clicks": 1,
            "spend": 0.04
        },
        {
            "age": "25-34",
            "gender": "unknown",
            "reach": 80,
            "cpc": 0.17,
            "impressions": 86,
            "clicks": 1,
            "spend": 0.17
        },
        {
            "age": "65+",
            "gender": "male",
            "reach": 0,
            "cpc": 0,
            "impressions": 1,
            "clicks": 0,
            "spend": 0
        },
        {
            "age": "18-24",
            "gender": "unknown",
            "reach": 58,
            "cpc": 0,
            "impressions": 58,
            "clicks": 0,
            "spend": 0.15
        }
    ],
    // can be used for IG + Presaves
    "platformClicksBreakdown": [
        {
            "serviceName": "Apple Music",
            "result": 41
        },
        {
            "serviceName": "Deezer",
            "result": 1
        },
        {
            "serviceName": "Spotify",
            "result": 212
        },
        {
            "serviceName": "Tidal",
            "result": 2
        }
    ],
    //  can be used for IG + Presaves
    "dailyStats": [
        {
            "date": "01/20",
            "totalSpend": 0.05,
            "totalReach": 25,
            "totalImpressions": 25,
            "totalClicks": 0,
            "clicks": "0",
            "inlineClicks": 0,
            "cpic": 0,
            "cpc": 0,
            "spend": 0.05,
            "costPerConversion": 0,
            "conversions": 0
        },
        {
            "date": "01/21",
            "totalSpend": 10.510000000000002,
            "totalReach": 4002,
            "totalImpressions": 4162,
            "totalClicks": 0,
            "clicks": "65",
            "inlineClicks": 47,
            "cpic": 0.222553,
            "cpc": 0.160923,
            "spend": 10.46,
            "costPerConversion": 0.290556,
            "conversions": 36
        },
        {
            "date": "01/22",
            "totalSpend": 21.32,
            "totalReach": 8245,
            "totalImpressions": 8505,
            "totalClicks": 0,
            "clicks": "77",
            "inlineClicks": 63,
            "cpic": 0.171587,
            "cpc": 0.14039,
            "spend": 10.81,
            "costPerConversion": 0.251395,
            "conversions": 43
        },
        {
            "date": "01/23",
            "totalSpend": 32.230000000000004,
            "totalReach": 12884,
            "totalImpressions": 13244,
            "totalClicks": 0,
            "clicks": "95",
            "inlineClicks": 70,
            "cpic": 0.155857,
            "cpc": 0.114842,
            "spend": 10.91,
            "costPerConversion": 0.158116,
            "conversions": 69
        },
        {
            "date": "01/24",
            "totalSpend": 43.290000000000006,
            "totalReach": 17996,
            "totalImpressions": 18574,
            "totalClicks": 0,
            "clicks": "104",
            "inlineClicks": 77,
            "cpic": 0.143636,
            "cpc": 0.106346,
            "spend": 11.06,
            "costPerConversion": 0.175556,
            "conversions": 63
        },
        {
            "date": "01/25",
            "totalSpend": 50.84,
            "totalReach": 21821,
            "totalImpressions": 22496,
            "totalClicks": 0,
            "clicks": "59",
            "inlineClicks": 38,
            "cpic": 0.198684,
            "cpc": 0.127966,
            "spend": 7.55,
            "costPerConversion": 0.228788,
            "conversions": 33
        }
    ],
    "topLevelPerformanceStats": {
        "primaryStats": [
            {
                "name": "Ads",
                "subtitle": "Total clicks on ads",
                "stats": [
                    {
                        "title": "Clicks",
                        "value": 564,
                        "displayType": "number" as const
                    },
                    {
                        "title": "Cost-per-click",
                        "value": 0.01,
                        "displayType": "currency" as const
                    },
                ]
            },
            {
                "name": "Lead Conversions",
                "subtitle": "Total clicks on ads",
                "stats": [
                    {
                        "title": "Total",
                        "value": 564,
                        "displayType": "number" as const
                    },
                    {
                        "title": "Cost-per-click",
                        "value": 0.10,
                        "displayType": "currency" as const
                    },
                ]
            }
        ],
        "secondaryStats": [
            {
                "title": "Clicks",
                "value": 564,
                "displayType": "number" as const
            },
            {
                "title": "Cost-per-click",
                "value": 0.01,
                "displayType": "currency" as const
            },
            {
                "title": "Post views",
                "value": 1922,
                "displayType": "number" as const
            },
            {
                "title": "Likes",
                "value": 9922922,
                "displayType": "number" as const
            },
            {
                "title": "Comments",
                "value": 17347,
                "displayType": "number" as const
            },
            {
                "title": "Shares",
                "value": 458,
                "displayType": "number" as const
            },
            {
                "title": "Post views",
                "value": 438498444,
                "displayType": "number" as const
            },
        ],
    },

    "markets": [
        {
            "id": "touring_markets",
            "name": "Touring Markets",
            "budget": 2500,
            "spent": 1250,
            "status": "live",
            "canPause": true,
        },
        {
            "id": "global_markets",
            "name": "Global Markets",
            "budget": 1800,
            "spent": 950,
            "status": "paused",
            "canPause": true,
        },
        {
            "id": "south_asian_markets",
            "name": "South Asian Markets",
            "budget": 1200,
            "spent": 600,
            "status": "live",
            "canPause": true,
        },
    ],

    "errors": [
        {
            "title": "Error 1",
            "subtitle": "Error 1 subtitle",
            "actions": [
                {
                    "title": "Action 1",
                    "onClick": "https://facebook.com/accountquality"
                }
            ]
        }
    ],

    "creativePerformanceStats": [
        {
            "title": "Reels",
            "value": 12969,
            "displayType": "number" as const
        },
        {
            "title": "IG Posts",
            "value": 12969,
            "displayType": "number" as const
        },
        {
            "title": "YT Shorts",
            "value": 12969,
            "displayType": "number" as const
        }
    ],

    "audienceStats": [
        {
            "name": "Audience 1",
            "subtitle": "this is audience 1",
            "canPause": true,
            "stats": [
                {
                    "title": "Clicks",
                    "value": 564,
                    "displayType": "number" as const
                },
                {
                    "title": "Cost-per-click",
                    "value": 0.01,
                    "displayType": "currency" as const
                },
                {
                    "title": "Reach",
                    "value": 1000,
                    "displayType": "number" as const
                }
            ]
        },
        {
            "name": "Audience 2",
            "subtitle": "this is audience 2",
            "canPause": true,
            "stats": [
                {
                    "title": "Clicks",
                    "value": 564,
                    "displayType": "number" as const
                },
                {
                    "title": "Cost-per-click",
                    "value": 0.01,
                    "displayType": "currency" as const
                },
                {
                    "title": "Reach",
                    "value": 1000,
                    "displayType": "number" as const
                }
            ]
        }
    ],
    "creativeStats": [
        {
            "name": "Ad 1",
            "subtitle": "this is ad 2",
            "thumbnail": "https://via.placeholder.com/150",
            "canPause": true,
            "stats": [
                {
                    "title": "Clicks",
                    "value": 564,
                    "displayType": "number" as const
                },
                {
                    "title": "Cost-per-click",
                    "value": 0.01,
                    "displayType": "currency" as const
                },
                {
                    "title": "Reach",
                    "value": 1000,
                    "displayType": "number" as const
                }
            ]
        },
        {
            "name": "Ad 2",
            "subtitle": "this is ad 2",
            "thumbnail": "https://via.placeholder.com/150",
            "canPause": true,
            "stats": [
                {
                    "title": "Clicks",
                    "value": 564,
                    "displayType": "number" as const
                },
                {
                    "title": "Cost-per-click",
                    "value": 0.01,
                    "displayType": "currency" as const
                },
                {
                    "title": "Reach",
                    "value": 1000,
                    "displayType": "number" as const
                }
            ]
        }
    ]
}


export const impactStatsData_mock: CampaignImpactStatsMetric[] = [
    {
        title: 'Spotify Followers',
        icon: 'spotify',
        data: {
            dailyStats: [
                {
                    datetime: '2024-01-01',
                    value: 1000
                },
                {
                    datetime: '2024-01-02',
                    value: 1050
                },
                {
                    datetime: '2024-01-03',
                    value: 1100
                },
                {
                    datetime: '2024-01-04',
                    value: 1150
                },
                {
                    datetime: '2024-01-05',
                    value: 1200
                },
                {
                    datetime: '2024-01-06',
                    value: 1250
                },
                {
                    datetime: '2024-01-07',
                    value: 1300
                }
            ],
            percentageChange: 5,
            netChange: 50,
            currentValue: 1050,
            secondaryStatTitle: 'Avg. Cost-per-follower',
            secondaryStatValue: 0.01
        }
    },
    {
        title: 'Instagram Followers',
        icon: 'instagram',
        data: {
            dailyStats: [
                {
                    datetime: '2024-01-01',
                    value: 1000
                },
                {
                    datetime: '2024-01-02',
                    value: 1050
                },
                {
                    datetime: '2024-01-03',
                    value: 1100
                },
                {
                    datetime: '2024-01-04',
                    value: 1150
                },
                {
                    datetime: '2024-01-05',
                    value: 1200
                },
                {
                    datetime: '2024-01-06',
                    value: 1250
                },
                {
                    datetime: '2024-01-07',
                    value: 1300
                }
            ],
            percentageChange: 5,
            netChange: 50,
            currentValue: 10500,
            secondaryStatTitle: 'Avg. Cost-per-follower',
            secondaryStatValue: 0.01
        }
    },
    {
        title: 'Spotify Streams',
        icon: 'spotify',
        data: {
            dailyStats: [
                {
                    datetime: '2024-01-01',
                    value: 1000
                },
                {
                    datetime: '2024-01-02',
                    value: 1050
                },
                {
                    datetime: '2024-01-03',
                    value: 1100
                },
                {
                    datetime: '2024-01-04',
                    value: 1150
                },
                {
                    datetime: '2024-01-05',
                    value: 1200
                },
                {
                    datetime: '2024-01-06',
                    value: 1250
                },
                {
                    datetime: '2024-01-07',
                    value: 1300
                }
            ],
            percentageChange: 5,
            netChange: 50,
            currentValue: 10500,
            secondaryStatTitle: 'Avg. Cost-per-follower',
            secondaryStatValue: 0.01
        }
    },
]

// getMarketStats
export const marketStatsData_mock = {
    "marketStats": [
        {
            "title": "Total streams",
            "value": 10000,
            "displayType": "number"
        },
        {
            "title": "Clicks",
            "value": 5390,
            "displayType": "number"
        },
        {
            "title": "Cost-per-click",
            "value": 0.01,
            "displayType": "currency"
        },
        {
            "title": "Cost-per-follower",
            "value": 2.33,
            "displayType": "currency"
        },
        {
            "title": "Total impressions",
            "value": 10000,
            "displayType": "number"
        },
        {
            "title": "Cost-per-impression",
            "value": 0.01,
            "displayType": "currency"
        },
        {
            "title": "Total likes",
            "value": 10000,
            "displayType": "number"
        },
    ],
    "tableData": [
        {
            "stats": {
                "cpm": 5.057977,
                "reach": 4805,
                "impressions": 5002,
                "spend": 25.3,
                "clicks": 66,
                "costPerClick": 0.383333,
                "costPerConversion": 0.414754,
                "conversions": 61
            },
            "id": "AU",
            "name": "Australia",
            "type": "country",
            "path": [
                "Australia"
            ],
            "status": "live",
            "canPause": true,
            "market": "Touring Markets"
        },
        {
            "stats": {
                "cpm": 4.157303,
                "reach": 87,
                "impressions": 89,
                "spend": 0.37,
                "clicks": 0,
                "costPerClick": 0,
                "costPerConversion": 0,
                "conversions": 0
            },
            "id": "130",
            "name": "Australian Capital Territory",
            "type": "region",
            "path": [
                "Australia",
                "Australian Capital Territory"
            ],
            "status": "live",
            "canPause": false
        },
        {
            "stats": {
                "cpm": 4.856795,
                "reach": 1573,
                "impressions": 1641,
                "spend": 7.97,
                "clicks": 20,
                "costPerClick": 0.3985,
                "costPerConversion": 0,
                "conversions": 0
            },
            "id": "131",
            "name": "New South Wales",
            "type": "region",
            "path": [
                "Australia",
                "New South Wales"
            ],
            "status": "live",
            "canPause": false
        },
        {
            "stats": {
                "cpm": 5.25,
                "reach": 39,
                "impressions": 40,
                "spend": 0.21,
                "clicks": 1,
                "costPerClick": 0.21,
                "costPerConversion": 0,
                "conversions": 0
            },
            "id": "132",
            "name": "Northern Territory",
            "type": "region",
            "path": [
                "Australia",
                "Northern Territory"
            ],
            "status": "live",
            "canPause": false
        },
        {
            "stats": {
                "cpm": 5.01331,
                "reach": 1084,
                "impressions": 1127,
                "spend": 5.65,
                "clicks": 20,
                "costPerClick": 0.2825,
                "costPerConversion": 0,
                "conversions": 0
            },
            "id": "133",
            "name": "Queensland",
            "type": "region",
            "path": [
                "Australia",
                "Queensland"
            ],
            "status": "live",
            "canPause": false
        },
        {
            "stats": {
                "cpm": 4.727273,
                "reach": 320,
                "impressions": 330,
                "spend": 1.56,
                "clicks": 6,
                "costPerClick": 0.26,
                "costPerConversion": 0,
                "conversions": 0
            },
            "id": "134",
            "name": "South Australia",
            "type": "region",
            "path": [
                "Australia",
                "South Australia"
            ],
            "status": "live",
            "canPause": false
        },
        {
            "stats": {
                "cpm": 7.954545,
                "reach": 41,
                "impressions": 44,
                "spend": 0.35,
                "clicks": 1,
                "costPerClick": 0.35,
                "costPerConversion": 0,
                "conversions": 0
            },
            "id": "135",
            "name": "Tasmania",
            "type": "region",
            "path": [
                "Australia",
                "Tasmania"
            ],
            "status": "live",
            "canPause": false
        },
        {
            "stats": {
                "cpm": 5.250227,
                "reach": 1049,
                "impressions": 1099,
                "spend": 5.77,
                "clicks": 11,
                "costPerClick": 0.524545,
                "costPerConversion": 0,
                "conversions": 0
            },
            "id": "136",
            "name": "Victoria",
            "type": "region",
            "path": [
                "Australia",
                "Victoria"
            ],
            "status": "live",
            "canPause": false
        },
        {
            "stats": {
                "cpm": 5.411392,
                "reach": 613,
                "impressions": 632,
                "spend": 3.42,
                "clicks": 7,
                "costPerClick": 0.488571,
                "costPerConversion": 0,
                "conversions": 0
            },
            "id": "137",
            "name": "Western Australia",
            "type": "region",
            "path": [
                "Australia",
                "Western Australia"
            ],
            "status": "live",
            "canPause": false
        }
    ]
}
